<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <tripTool ref="tripTool" showCustomer :showAddButton="false" />
    </a-card>
</template>
<script>
import tripTool from "../../views/trip/tripTool.vue";
export default {
    components: {
        tripTool
    },
    data() {
        return {
            haibaoall: []
        }
    }
}
</script>